import { Injectable } from '@angular/core';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { CopyService } from '../services/copy.service';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  constructor(private copyService: CopyService){
    super();
  }
  override async updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    let programname = await this.copyService.getCopyByKey('programName');
    if (title !== undefined) {
      document.title = `${programname} - ${title}`;
    } else {
      document.title = `${programname}`;
    }
  }
} 